// Rapportvakt — turn one GET /editions row into the shape <Delivery> renders.
//
// The backend's EditionOut/PointOut (app/schemas.py) carry snake_case field
// names straight off the Postgres columns. <Delivery> (Delivery.jsx) was
// built for RAPPORTVAKT_DELIVERIES entries (config/rapportvakt.js) and
// RAPPORTVAKT_DIGESTS (config/digests.js), both already camelCase. This is
// the runtime twin of what scripts/export_digests.py's point_payload/
// digest_payload do at export time for the public digest pages — same field
// mapping, done here in the browser instead, for a subscriber's own latest
// edition on the Utskick tab.
//
// Pure and side-effect free on purpose, so the mapping can be unit tested
// without a network call or a rendered page (see
// web/tests/editionDelivery.test.js).

/** One PointOut row -> the point shape Delivery.jsx/PointVisual.jsx read. */
function pointToDeliveryPoint(point) {
  return {
    id: point.key,
    impact: point.impact,
    lead: point.lead,
    headline: point.headline,
    verdict: point.verdict,
    hero: point.hero,
    visual: point.visual,
    facts: point.facts,
    detail: point.detail,
    quote: point.quote,
    citationShort: point.citation_short,
    citation: {
      pages: point.citation_pages,
      sections: point.citation_sections,
      url: point.citation_url,
      linkLabel: point.citation_link_label,
      extra: point.citation_extra,
    },
    citationKind: point.citation_kind,
  };
}

/**
 * One EditionOut -> the `delivery` prop <Delivery> expects.
 *
 * `reportPageUrl` falls back the same way RapportvaktDigestPage.jsx's
 * deliveryView does for a digest with no report page of its own: the
 * edition's own report_page_url first, then its pdf, then its first source
 * item's link — whichever is the closest thing to "where this reading
 * starts".
 */
export function editionToDelivery(edition) {
  const items = edition.items || [];
  return {
    publisher: edition.publisher_name || edition.series?.publisher?.name || '',
    dateLabel: edition.date_label || edition.date_iso || '',
    title: edition.title,
    reportPageUrl: edition.report_page_url || edition.pdf_url || items[0]?.url || '',
    points: (edition.points || []).map(pointToDeliveryPoint),
  };
}
